import { inject, Injectable } from '@angular/core';
import { SyncStore } from '../../storage/sync-store/sync-store';
import { SyncStoreSaveData } from '../../storage/sync-store/update-data/sync-store-save-data';
import { SyncStoreUpdateAnimalWeighing } from '../../storage/sync-store/update-data/sync-store-update-animal-weighing';
import { SyncStoreUpdateBatchWeighing } from '../../storage/sync-store/update-data/sync-store-update-batch-weighing';
import { SyncStoreUpdateRemoval } from '../../storage/sync-store/update-data/sync-store-update-removal';

@Injectable({
  providedIn: 'root',
})
export class SyncStoreWriter {
  private readonly store = inject(SyncStore);

  constructor() {}

  persistAnimalWeighings(syncData: SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>): void {
    this.store.storePersistAnimalWeighings(syncData);
  }
  persistBatchWeighing(syncData: SyncStoreSaveData<SyncStoreUpdateBatchWeighing>): void {
    this.store.storePersistBatchWeighings(syncData);
  }
  persistRemovals(syncData: SyncStoreSaveData<SyncStoreUpdateRemoval>): void {
    this.store.storePersistRemovals(syncData);
  }
  clear(): void {
    this.store.clear();
  }
}
